module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-base"
    }
  }, [_c('app-nav'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e124ede"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainBase.vue
// module id = 1005
// module chunks = 1